import { PermissionData } from "@/common/types/permissions"
import { ArrowBigRight } from "lucide-react"
import { Link } from "react-router-dom"

export class PermissionsTransformer {
  static tableTransformer() {
    return (permissions: PermissionData[]) => {
      return permissions.map((permission) => {
        return {
          ...permission,
          actions: <Link to={`/permissions/${permission.id}`}><ArrowBigRight /></Link>
        }
      })
    }
  }
}
